@import 'styles/variables';

.error {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $gray-60;
}
